import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "aviaCard__slider" }
const _hoisted_2 = { class: "aviaCard__slider__routes" }
const _hoisted_3 = { class: "lineInfo" }
const _hoisted_4 = { class: "lineInfo__route" }
const _hoisted_5 = { class: "lineInfo__time" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "lineInfo__info" }, null, -1)
const _hoisted_7 = { class: "lineInfo__port" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_9 = { class: "lineInfo__airplane" }
const _hoisted_10 = { class: "lineInfo__type" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allFly, (fly) => {
        return (_openBlock(), _createBlock("li", {
          key: fly.key
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(fly.from) + " (" + _toDisplayString(fly.fromName) + ") → " + _toDisplayString(fly.to) + " (" + _toDisplayString(fly.toName) + ") ", 1),
            _createVNode("div", _hoisted_5, _toDisplayString(fly.time), 1),
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createTextVNode(_toDisplayString(fly.marketingAirline) + " ", 1 /* TEXT */),
              _createVNode("span", null, "(" + _toDisplayString(fly.codeA) + ")", 1),
              _hoisted_8
            ]),
            _createVNode("div", _hoisted_9, _toDisplayString(fly.airplane) + " | " + _toDisplayString(fly.airline) + " " + _toDisplayString(fly.airplaneCode) + " | " + _toDisplayString(fly.number), 1)
          ]),
          _createVNode("div", _hoisted_10, _toDisplayString(fly.fareName), 1)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}